import React, { useEffect, useState } from 'react';

import { Popover, OverlayTrigger, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight, faCog } from '@fortawesome/pro-solid-svg-icons';

/* istanbul ignore next */
const PaginatedListNavigation = ({
  currentPage,
  totalResults,
  onPrevPage,
  onNextPage,
  columnVisibility,
  onToggleColumn,
  rowsPerPage,
  setRowsPerPage,
  showSettings,
}) => {
  const [showPopover, setShowPopover] = useState(false);
  const [inputValue, setInputValue] = useState(rowsPerPage.toString());

  useEffect(() => {
    setInputValue(rowsPerPage);
  }, [rowsPerPage]);

  const start = totalResults > 0 ? currentPage * rowsPerPage + 1 : 0;
  const end = Math.min((currentPage + 1) * rowsPerPage, totalResults);
  const isLastPage = ((currentPage + 1) * rowsPerPage) >= totalResults;

  const popover = (
    <Popover id="popover-basic" show={showPopover}>
      <Popover.Content>
        <b>Rows per page</b>
        <input
          style={{
            display: 'block',
            width: '60px',
            height: '40px',
            padding: '10px',
            fontSize: '22px',
            margin: '10px auto',
            boxSizing: 'border-box',
          }}
          type="number"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onBlur={() => {
            const newRowsPerPage = inputValue === '' ? 0 : Number(inputValue);
            setRowsPerPage(newRowsPerPage);
          }}
        />
        <div className="mb-2"><b className="mb-2">Display columns</b></div>
        {Object.entries(columnVisibility).map(([name, visible], index) => (
          <div
            key={name}
            className="form-check align-items-center d-flex pb-1"
          >
            <input
              className="form-check-input"
              type="checkbox"
              checked={visible}
              id={`customCheck${index}`}
              onChange={(e) => onToggleColumn(name, e.target.checked)}
            />
            <label className="form-check-label" htmlFor={`customCheck${index}`}>
              {name}
            </label>
          </div>
        ))}
      </Popover.Content>
    </Popover>
  );

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    }}
    >
      <div style={{
        display: 'flex',
        alignItems: 'center',
      }}
      >
        <span className="text-muted mr-2">{`${start} - ${end} of ${totalResults}`}</span>
        <Button variant="link" onClick={onPrevPage} className="text-muted" disabled={currentPage === 0}>
          <FontAwesomeIcon
            icon={faChevronLeft}
            size="lg"
            className="text-muted"
          />
        </Button>
        <Button variant="link" onClick={onNextPage} className="text-muted" disabled={isLastPage}>
          <FontAwesomeIcon
            icon={faChevronRight}
            size="lg"
            className="text-muted"
          />
        </Button>
        {showSettings && (
        <OverlayTrigger trigger="click" placement="bottom" overlay={popover} rootClose>
          <Button variant="link" onClick={() => setShowPopover(true)}>
            <FontAwesomeIcon icon={faCog} size="lg" className="text-muted" />
          </Button>
        </OverlayTrigger>
        )}
      </div>
    </div>
  );
};

PaginatedListNavigation.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalResults: PropTypes.number.isRequired,
  onPrevPage: PropTypes.func.isRequired,
  onNextPage: PropTypes.func.isRequired,
  columnVisibility: PropTypes.objectOf(PropTypes.bool).isRequired,
  onToggleColumn: PropTypes.func.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  setRowsPerPage: PropTypes.func.isRequired,
  showSettings: PropTypes.bool,
};

PaginatedListNavigation.defaultProps = {
  showSettings: true,
};

export default PaginatedListNavigation;
